import { Config, createConfig } from 'wagmi'
import { safe } from 'wagmi/connectors'

import { extendConfig } from '@eulerxyz/wagmi-evc'
import { getChains } from './getChains'
import { getTransports } from './getTransports'
import { createWagmiStorage } from './storage'

export function getSafeConfig(): Config {
  const transports = getTransports({})
  const chains = getChains({})
  const storage = createWagmiStorage()

  const baseConfig = createConfig({
    chains,
    transports,
    storage,
    connectors: [safe()],
    multiInjectedProviderDiscovery: false,
    ssr: true,
  })

  const config = extendConfig(baseConfig)

  return config as unknown as Config
}
